import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Token',
    entityNamePlural: 'Tokens',
    entityNameModule: 'settings',
    filters: { active: true },
  }), [])
}
